// Modules
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Components
import { loginPageGdmComponent } from '@pages/login-page-gdm/login-page-gdm.component';

const routes: Routes = [
  // {
  //   path: '',
  //  data: {
  //     title: 'Login Page'
  //   },
  //   children: [
  //     {
  //       path: '',
  //       component: loginPageGdmComponent,
  //       data: {
  //         title: ''
  //       }
  //     }
  //   ]
  // },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LoginRoutingModule {
  static components = [ loginPageGdmComponent ];
}
